import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { FormattedMessage } from 'react-intl';

import css from './SearchMapGroupLabel.module.css';

const HOVER_DELAY = 250; // milliseconds
const MOBILE_BREAKPOINT = 1024;

class SearchMapGroupLabel extends Component {
  constructor(props) {
    super(props);
    this.hoverTimeout = null;
    this.isMobile = typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
  }

  componentWillUnmount() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }

  shouldComponentUpdate(nextProps) {
    const hasSameAmountOfListings = nextProps.listings.length === this.props.listings.length;
    const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
    const hasSameRefreshToken =
      this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;

    return !(hasSameAmountOfListings && hasSameActiveStatus && hasSameRefreshToken);
  }

  handleMouseEnter = () => {
    // Only trigger hover on desktop
    if (this.isMobile) return;

    const { listings, onListingClicked } = this.props;

    // Clear any existing timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }

    // Set timeout to trigger hover after delay
    this.hoverTimeout = setTimeout(() => {
      onListingClicked(listings);
    }, HOVER_DELAY);
  };

  handleMouseLeave = () => {
    // Clear hover timeout if mouse leaves before delay
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  };

  handleClick = () => {
    // Clear hover timeout on click
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    const { listings, onListingClicked } = this.props;
    onListingClicked(listings);
  };

  render() {
    const { className, rootClassName, listings, onListingClicked, isActive, isInfoCardSelection } = this.props;
    const shouldAnimate = isActive && !isInfoCardSelection;
    const classes = classNames(rootClassName || css.root, className, shouldAnimate ? css.activeJump : null);
    const countLabelClasses = classNames(css.details, { [css.detailsActive]: isActive });
    const caretClasses = classNames(css.caret, { [css.caretActive]: isActive });

    return (
      <button
        className={classes}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className={css.caretShadow} />
        <div className={countLabelClasses}><FormattedMessage id="SearchMapGroupLabel.items" defaultMessage="Items" values={{ count: listings.length }} /> </div>
     
        <div className={caretClasses} />
      </button>
    );
  }
}

SearchMapGroupLabel.defaultProps = {
  className: null,
  rootClassName: null,
  isInfoCardSelection: false,
};

const { arrayOf, bool, func, string } = PropTypes;

SearchMapGroupLabel.propTypes = {
  className: string,
  rootClassName: string,
  isInfoCardSelection: bool,
  listings: arrayOf(propTypes.listing).isRequired,
  onListingClicked: func.isRequired,
};

export default SearchMapGroupLabel;
